import React from 'react';
import { createRoot } from 'react-dom/client';
import AlertModal from './AlertModal';

export function confirmAlert(options) {
    return new Promise((resolve) => {
        let container = document.getElementById('custom-alert-container');
        if (!container) {
            container = document.createElement('div');
            container.id = 'custom-alert-container';
            document.body.appendChild(container);
        }
        
        const root = createRoot(container);
        
        const cleanup = () => {
            // Unmount and remove container after a small delay
            setTimeout(() => {
                root.unmount();
                if (container.parentNode) {
                    container.parentNode.removeChild(container);
                }
            }, 50);
        };

        const handleConfirm = () => {
            cleanup();
            resolve(true);
        };

        const handleCancel = () => {
            cleanup();
            resolve(false);
        };

        root.render(
            <AlertModal 
                isOpen={true} 
                title={options.title || "Confirmation"} 
                message={options.message || "Êtes-vous sûr ?"} 
                onConfirm={handleConfirm} 
                onCancel={handleCancel}
                confirmText={options.confirmText || "Confirmer"}
                cancelText={options.cancelText || "Annuler"}
                type={options.type || "danger"}
            />
        );
    });
}
